import { FormControl, MenuItem, Select } from '@mui/material';
import { useState } from 'react';
import { useTheme } from 'styled-components';
import { ReactComponent as IconawesomeUserAlt } from '../../assets/icons/IconawesomeUserAlt.svg';
import { ReactComponent as ExpandArrowIcon } from '../../assets/icons/iconExpandArrow.svg';
import { NavHeader } from '../../components';
import { useDepartments } from '../../context';
import { Body, Container, Content, Form } from './styles';

export function SelectedLogin() {
  const theme = useTheme();
  const { departments } = useDepartments();
  const [userId, setUserId] = useState('');
  const MenuProps = {
    PaperProps: {
      style: {
        backgroundColor: theme.colors.background_white,
        color: theme.colors.secondary,
      },
    },
  };

  return (
    <Body>
      <NavHeader typeHeader="default" />
      <Container>
        <h1>Escolher conta</h1>
        <Content>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
            }}>
            <Form>
              <div className="contentGrid">
                <div className="header">
                  <div>
                    <IconawesomeUserAlt />
                  </div>
                  <p>Selecione em qual perfil você quer entrar</p>
                </div>
                <div className="optionUser">
                  <FormControl fullWidth>
                    <Select
                      name="department"
                      classes={{ select: 'select-style' }}
                      defaultValue={userId}
                      MenuProps={MenuProps}
                      value={userId}
                      displayEmpty
                      IconComponent={ExpandArrowIcon}
                      onChange={(e) => setUserId(e.target.value as string)}>
                      <MenuItem value="">Selecione</MenuItem>
                      {departments
                        .filter((d) => d.isActive)
                        .map((department) => (
                          <MenuItem value={department.id} key={department.id}>
                            {department.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </div>
              </div>
            </Form>
          </div>
          <div className="buttonDiv">
            <button type="submit">Entrar</button>
          </div>
        </Content>
      </Container>
    </Body>
  );
}
